import { render, staticRenderFns } from "./WorksPanel.vue?vue&type=template&id=13b5bdaa"
import script from "./WorksPanel.vue?vue&type=script&lang=js"
export * from "./WorksPanel.vue?vue&type=script&lang=js"
import style0 from "./WorksPanel.vue?vue&type=style&index=0&id=13b5bdaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports